module.exports = __webpack_public_path__ + "static/media/3DPPA21.33f3aedd.jpg";